angular.module('lingoda.scroller', [])
.directive('customscroll', ['$timeout', function($timeout) {
    return {
        restrict:'C',
        transclude: true,
        template: '<div class="customscroll-content" data-ng-transclude></div>',
        link: function(scope, element) {
            var iscroll = new IScroll(element[0], $.extend({
                scrollbars: true,
                mouseWheel: true,
                interactiveScrollbars: true,
                shrinkScrollbars: 'scale',
                fadeScrollbars: false,
                click: true
            }, element.data()));

            scope.$on('iscroll:refresh', function() {
                $timeout(function() {
                    iscroll.refresh();
                });
                $timeout(function() {
                    iscroll.refresh();
                }, 100);
            });

            var syncModel = function() {
                scope.customscroll = {
                    x: iscroll.x,
                    y: iscroll.y
                };
                scope.$apply();
            };

            iscroll.on('scroll', syncModel);
            iscroll.on('scrollEnd', syncModel);

            $(window).on('resize', syncModel);
        }
    }
}]);
